"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const styles = (0, _makeStyles.default)(theme => {
  var _theme$palette, _theme$palette2, _theme$palette3;
  return {
    filter: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "wrap",
      "& .mco-filter-item__select": {
        marginRight: theme.spacing(1)
      },
      "& .mco-filter-item__label": {
        color: theme.palette.text.primary
      },
      "& .mco-filter-item__slider": {
        "& .MuiSlider-thumb": {
          background: (_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.primary) === null || _theme$palette === void 0 ? void 0 : _theme$palette.main
        },
        "& .MuiSlider-track": {
          background: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 || (_theme$palette2 = _theme$palette2.grey) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2[400]
        }
      },
      "& .mco-filter-item__values": {
        "& p": {
          color: (_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 || (_theme$palette3 = _theme$palette3.text) === null || _theme$palette3 === void 0 ? void 0 : _theme$palette3.secondary
        }
      },
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        gap: theme.spacing(1)
      }
    },
    titleWrapper: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      marginBottom: theme.spacing(1.5)
    },
    title: {
      fontSize: "1.5rem",
      fontWeight: theme.typography.fontWeightBold
    },
    closeButton: {
      marginRight: -4
    },
    searchField: {
      background: "#FFFFFF"
    }
  };
});
var _default = exports.default = styles;